<script>
export default {
  name: "detail-button",
  props: {
    imageSrc: { type: String, required: true },
    title: { type: String, required: true },
    disabled: { type: Boolean, required: true },
    outline: { type: Boolean, default: true }
  },
  methods: {
    clicked() {
      if (this.disabled) return;
      this.$emit("clicked");
    }
  }
};
</script>

<template>
  <v-btn
    @click="clicked()"
    :disabled="disabled"
    class="action-buttons"
    :outlined="outline"
    block
    color="primary"
  >
    <v-layout align-center justify-center row fill-height wrap>
      <v-flex class="text-xs-right">
        <v-avatar tile size="32px">
          <img :src="imageSrc" />
        </v-avatar>
      </v-flex>
      <v-flex class="text-xs-left">
        <span class="title-form">{{ title }}</span>
      </v-flex>
    </v-layout>
  </v-btn>
</template>

<style scoped>
.v-btn--small {
  font-size: 10px;
  height: 18px;
  padding: 0px;
}
strong {
  font-weight: bold;
}
p {
  font-size: 15px;
}
img {
  padding: 2px;
}
.v-btn.action-buttons {
  height: auto;
  min-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Orders/Show/DetailButton.vue